import script from "./contactComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./contactComponent.vue?vue&type=script&setup=true&lang=js"

import "./contactComponent.vue?vue&type=style&index=0&id=03dbfa17&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-03dbfa17"]])

export default __exports__